import {
  ApiUser,
  ApiUserProfileSetting,
} from "types/api-user";
import { API_PAGE_LIMIT, BaseApi } from "./base.apis";
import { SieveSearchRequestQuery } from "types/sieve.types";
import { getFilters, getSorts } from "utils/sieve.utils";
import { PagedContent } from "types/api.types";
import apiInstance from "utils/axios";

export class UsersApi extends BaseApi<ApiUser> {
  relativeUrl: string = "users";
  queryKeyName: string = "users";

  public async getMeAsync(): Promise<ApiUser> {
    return apiInstance.get(`/api/${this.relativeUrl}/me`);
  }
}